import { withPublicImageUrl } from '@lib/utils/cdn'

import { Row } from '@components/ui-core/row/row'
import { Text } from '@components/ui-core/text/text'

import style from './card.module.scss'

export const Card = ({
  title,
  icon,
  description,
  added,
}: {
  title: string
  icon: () => React.ReactNode
  description: string
  added: boolean
}) => {
  return (
    <div className={style.card}>
      <Row crossAxisAlignment="center" gap="2x" className={style.cardHeader}>
        {icon()}
        <Text fontWeight="bold">{title}</Text>
      </Row>
      <Text className={style.description}>{description}</Text>
      <div className={style.button}>
        {added && (
          <span
            className={style.checkedIcon}
            style={{
              backgroundImage: `url(${withPublicImageUrl('superhuman-go-intro-checked.svg')})`,
            }}
          />
        )}
        <Text as="span" className={style.buttonText}>
          {added ? 'Added' : 'Add'}
        </Text>
      </div>
    </div>
  )
}
